import type { UI } from '@/v2/types';

import useSortedMainRoomOptions from '@shared/v2/hooks/useSortedMainRoomOptions';

import { useRoomOptionsData } from '@/v2/components/pages/PackageView/contexts/RoomOptionsContext';
import RoomList from '../RoomList';

export type MainRoomsProps = {
  roomOptions: UI.RoomOption[] | undefined | null;
};

const MainRooms = ({ roomOptions }: MainRoomsProps) => {
  const { route, isPreSearch, isOriginAndPackageSelected } =
    useRoomOptionsData() || {};

  const sortedRoomOptions = useSortedMainRoomOptions({
    roomOptions,
    isOriginAndPackageSelected,
    isPreSearch,
    route,
  });

  return (
    <RoomList
      data-testid="MAIN_ROOMS"
      roomOptions={sortedRoomOptions}
      isMainRooms
    />
  );
};

export default MainRooms;
